export default "__VITE_ASSET__CxdcrS9x__"